import React from 'react'
import DetailDoctorService from '../Service/DetailDoctorService'
import { config } from '../Config/config'
import './doctortreatment.css'
import FormSpesialisasi from './formSpesialisasi'
import Detail_Doctor from './index'


export default class index extends React.Component {
    DoctorSpModel = {
        doctor_id: "",
        specialization_id: ""
    }
    constructor() {
        super()
        this.state = {
            bioList: [],
            sp: "", ganti:"",
            listSP: [],
            tombol: "",
            Model: this.DoctorSpModel,
            ShowModal: false,
            ShowModalEdit: false,
            ShowModalEditBerhasil: false,
            ShowModalfunc:false,
            Mode: "",
            data: {
                id_doctor: ""
            }
        }
    }

    loadList = async () => {
        const responID = await DetailDoctorService.getID(localStorage.getItem(config.biodata_id))
        if (responID.success) {
            this.setState({
                dokter_id: responID.result
            })
            {
                this.state.dokter_id.map(data => {
                    this.setState({
                        data : {
                            ...this.state.data,
                            id_doctor : data._id
                        }
                    })
                })
            }
        }
        const {data}=this.state
        this.setState({
            Model: {
                ...this.state.Model,
                doctor_id: data.id_doctor
            }
        })
        const responBio = await DetailDoctorService.getBiodata(this.state.data)
        if (responBio.success) {
            this.setState({
                bioList: responBio.result,
            })
            {
                this.state.bioList.map(data => {
                    this.setState({
                        sp : data.sp
                    })
                })
            }
        }
        
        if (this.state.sp.length == 0){
            this.setState({
                text: "Anda belum menambahkan spesialisasi",
                tombol: "fa fa-plus plus-circle",
                Mode: "Tambah Spesialisasi",
            })
        }else{
            this.setState({
                text: this.state.sp,
                tombol: "fa fa-edit plus-circle",
                Mode: "Perbarui Spesialisasi",
            })
        }
    }
    componentDidMount() {
        this.loadList()
    }

    createHandler = () => {
        this.setState({
            ShowModal: true,
            // ShowModalBerhasilSimpan: true
            // ShowModalSimpan: true,
            // Model: this.DoctorTreatmentModel
        })

    }
    cancelHandler = () => {
        this.setState({
            ganti:"",
            ShowModal: false,
            ShowModalEdit: false,
            ShowModalEditBerhasil: false,
            //ShowModalBerhasilSimpan: false
        })
    }
    alertHandler = () => {
        this.setState({
            ShowModalAlert: false,
            ShowModal: true
        })
    }
    noneHandler = () => {
        this.setState({
            ShowModalfunc: true
        })
    }
    editHandler = () => {
        if (this.state.ganti.length>0){
            this.setState({
                //ShowModal:false,
                ShowModalEdit: true,
                //ShowModalEditBerhasil: false,
                //ShowModalBerhasilSimpan: false
            })
        }else{
            this.setState({
                ShowModalAlert:true
            })
        }
    }
    saveHandler = async () => {
        if (this.state.Mode == "Tambah Spesialisasi") {
                const respond = await DetailDoctorService.addSP(this.state.Model)

                if (respond.success) {
                    this.loadList()
                    this.setState({
                        Model: this.DoctorSpModel,
                        ShowModal: false,
                        ShowModalEdit: false,
                        ShowModalEditBerhasil: true
                    })
                    
                }
        }
        if (this.state.Mode == "Perbarui Spesialisasi") {
            const respond = await DetailDoctorService.editSP(this.state.Model)

            if (respond.success) {
                this.loadList()
                this.setState({
                    Model: this.DoctorSpModel,
                    ShowModal: false,
                    ShowModalEdit: false,
                    ShowModalEditBerhasil: true
                })
                
            }
        }
    }
    spHandler = async () => {
        const{Model}=this.state
        console.log(Model.specialization_id)
        const responsp = await DetailDoctorService.getESP(Model.specialization_id)
        if (responsp.success) {
            this.setState({
                ganti: responsp.result[0].name
            })
        }
    }
    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        }, () => this.spHandler())
        //this.loadList()
        //this.spHandler()
    }

    render() {
        const {tombol, ShowModal, Mode, ShowModalEdit, ShowModalEditBerhasil,
                ShowModalAlert, ShowModalfunc} = this.state
        const {list_sp} = this.props
        return (
            <div>
                {/* {JSON.stringify(this.state.ganti)} */}
                <div class="container">
                    <div class="text-left">
                        <h5>{this.state.text}</h5>
                    </div>

                    <div class="tab-content" style={{ height: 500 }}>
                        <div class="tab-pane show active" id="spesialisasi">
                            <div class="button">
                            
                            </div>
                        
                        <button type="button" class="btn btn-circle btn-primary mb-3 float-right bawah tambah" onClick={this.createHandler}><i class={tombol} ></i>
                        <i> </i></button>
                        </div>
                    </div>
                    <FormSpesialisasi
                        list_sp={list_sp}
                        saveHandler={this.saveHandler}
                        ShowModal={ShowModal}
                        ShowModalEdit={ShowModalEdit}
                        ShowModalAlert={ShowModalAlert}
                        ShowModalEditBerhasil={ShowModalEditBerhasil}
                        noneHandler={this.noneHandler}
                        changeHandler={this.changeHandler}
                        alertHandler={this.alertHandler}
                        ganti={this.state.ganti}
                        //createHandler={this.createHandler}
                        cancelHandler={this.cancelHandler}
                        editHandler={this.editHandler}
                        //handleValidation={this.handleValidation}
                        Mode={Mode}
                        text={this.state.text}
                    />
                    

                </div>

            </div >
        )
    }
}